import { render, staticRenderFns } from "./articleCardPreview.vue?vue&type=template&id=6e94d85e&scoped=true"
import script from "./articleCardPreview.vue?vue&type=script&lang=js"
export * from "./articleCardPreview.vue?vue&type=script&lang=js"
import style0 from "./articleCardPreview.vue?vue&type=style&index=0&id=6e94d85e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e94d85e",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QImg});
